import { posthogConfigError } from '../lib/posthog.ts'

/**
 * Dev-only banner for configuration that is wrong but not fatal.
 *
 * The failure this replaces was a module-scope `throw`, which blanked the page with no console
 * error and no Vite overlay (RAL-204). The intent behind it was sound — a missing analytics key
 * should not be easy to ignore — so this keeps the loudness and drops the fatality: the app boots
 * and works, and the problem is stated on screen rather than inferred from an empty document.
 *
 * Renders nothing in production and under test: `posthogConfigError` is already null in both.
 */
export function DevConfigWarning() {
  if (!posthogConfigError) return null

  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-0 z-50 border-signal-fail-border border-t bg-signal-fail-bg px-4 py-2 font-mono text-[11px] leading-snug text-signal-fail"
    >
      <strong className="font-semibold">Dev config:</strong> {posthogConfigError} Set it in the PARAMS blob you start
      Vite with — see CLAUDE.md's local-dev recipe. The app still works; analytics do not.
    </div>
  )
}
